import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { CheckCircle2 } from "lucide-react";
import client, { formatErr } from "../lib/api";
import { toast } from "sonner";

export default function DailyCard({ onChange }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const load = () => client.get("/daily-challenge").then((r) => setData(r.data));
    useEffect(() => {
        load();
    }, []);

    const complete = async () => {
        setLoading(true);
        try {
            await client.post("/daily-challenge/complete");
            toast.success("Daily crushed. Streak alive.");
            await load();
            if (onChange) onChange();
        } catch (e) {
            toast.error(formatErr(e));
        } finally {
            setLoading(false);
        }
    };

    if (!data) return null;
    const c = data.challenge;
    const Icon = Icons[c.icon] || Icons.Activity;
    const done = !!data.completion;

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="surface-2 p-4 relative overflow-hidden"
            data-testid="daily-card"
            style={{
                borderLeft: `3px solid ${done ? "#39FF14" : "#39FF14"}`,
            }}
        >
            <div className="flex items-center gap-3">
                <div
                    className="w-12 h-12 flex items-center justify-center"
                    style={{ background: "#39FF1415", border: "1px solid #39FF14" }}
                >
                    <Icon size={20} className="text-neon-green" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="label-cap text-[10px] text-neon-green flex items-center gap-2">
                        Today's Daily
                        {done && (
                            <span className="text-neon-green flex items-center gap-1">
                                <CheckCircle2 size={11} /> DONE
                            </span>
                        )}
                    </div>
                    <div className="font-display font-black text-lg uppercase tracking-tight leading-tight">
                        {c.title}
                    </div>
                    <div className="text-xs text-zinc-400 mt-0.5">
                        {c.target} {c.unit} · +{c.xp_reward} XP
                    </div>
                </div>
            </div>
            {!done ? (
                <button
                    onClick={complete}
                    disabled={loading}
                    data-testid="daily-complete-btn"
                    className="btn-neon w-full py-2 mt-3 text-sm disabled:opacity-50"
                >
                    {loading ? "Logging..." : "Mark Done"}
                </button>
            ) : (
                <div className="mt-3 surface-3 py-2 text-center label-cap text-[11px] text-neon-green">
                    Locked in for today. Come back tomorrow.
                </div>
            )}
        </motion.div>
    );
}
